var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4426 7.73357C13.2578 7.92139 13.0133 8.01381 12.7688 8.01381C12.5244 8.01381 12.2805 7.92065 12.0945 7.73432L8.9528 4.59429V13.7378C8.9528 14.2652 8.52558 14.665 8.02562 14.665C7.52566 14.665 7.04478 14.2655 7.04478 13.7378V4.59429L3.90342 7.73357C3.53076 8.10623 2.92706 8.10623 2.5544 7.73357C2.18174 7.36091 2.18174 6.75721 2.5544 6.38455L7.32443 1.61452C7.69709 1.24186 8.30079 1.24186 8.67345 1.61452L13.4435 6.38455C13.8152 6.7587 13.8152 7.36091 13.4426 7.73357Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.a0eb19aa979910f2c890b4f7aef8c846.svg";
export { ForwardRef as ReactComponent };